import {
    Component,
    Input,
    ViewChild,
    OnInit,
    AfterViewInit,
    HostListener
} from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import {
    PopperController
} from 'ngx-popper';

@Component({
    selector: 'app-decoration-pixelization-list-item',
    templateUrl: './decoration-pixelization-list-item.component.pug',
    styleUrls: ['./decoration-pixelization-list-item.component.less']
})
export class DecorationPixelizationListItemComponent implements AfterViewInit, OnInit {
    @Input() decoration: any;

    _themesSbj: BehaviorSubject<any[]> = new BehaviorSubject([]);
    @Input() set themes(themes) {
        this._themesSbj.next(themes);
    }

    theme$ = this._themesSbj.asObservable().pipe(map((themes) => {
        const _theme = themes.find(({ value }) => this.decoration.theme === value) || {};

        return _theme.name || '';
    }));

    @ViewChild('figure', {static: false}) figure;
    @ViewChild(PopperController, {static: false}) popper;

    @HostListener('mouseover', [])
    onShow() {
        this.popper.show();
    }

    @HostListener('mouseout', [])
    onHide() {
        this.popper.hide();
    }

    constructor(
    ) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const top = this.figure.nativeElement.parentElement.offsetTop;
            const left = this.figure.nativeElement.parentElement.offsetLeft;

            this.figure.nativeElement.style.top = `${ top }px`;
            this.figure.nativeElement.style.left = `${ left }px`;
        });
    }

    trackByFn(index, item) {
        return item._id;
    }
}


